module.exports = __webpack_public_path__ + "media/alert_sound.7951dc59.wav";